import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ValueProp {
  icon: string;
  title: string;
  description: string;
  benefits: string[];
}

const ValuePropositionSection = () => {
  const valueProps: ValueProp[] = [
    {
      icon: 'BriefcaseIcon',
      title: 'Enterprise Client Access',
      description: 'Direct access to Fortune 500 and FTSE 100 organizations seeking AI transformation expertise.',
      benefits: [
        'Pre-qualified enterprise opportunities',
        'Warm introductions to decision-makers',
        'Ongoing client relationships',
        'Revenue share on successful engagements'
      ]
    },
    {
      icon: 'AcademicCapIcon',
      title: 'Proven Methodologies',
      description: 'Battle-tested frameworks and playbooks that accelerate delivery and reduce implementation risk.',
      benefits: [
        'AI adoption readiness assessments',
        'Change management frameworks',
        'Implementation playbooks',
        'Continuous methodology updates'
      ]
    },
    {
      icon: 'UsersIcon',
      title: 'Professional Network',
      description: 'Collaborate with senior consultants and boutique firms in a curated professional alliance.',
      benefits: [
        'Peer learning and knowledge sharing',
        'Collaborative delivery opportunities',
        'Quarterly partner summits',
        'Private community platform'
      ]
    },
    {
      icon: 'ChartBarIcon',
      title: 'Brand Differentiation',
      description: 'Position yourself as an AI change leadership specialist with recognized credentials.',
      benefits: [
        'AI Change Leaders certification',
        'Co-branded marketing materials',
        'Thought leadership opportunities',
        'Industry recognition and visibility'
      ]
    }
  ];

  return (
    <section id="benefits" className="py-20 lg:py-32 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-bold font-headline text-primary mb-6">
            Why Join AI Change Leaders?
          </h2>
          <p className="text-lg text-muted-foreground font-body">
            We provide everything you need to differentiate your practice and deliver exceptional AI transformation outcomes for enterprise clients.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {valueProps.map((prop, index) => (
            <div
              key={index}
              className="bg-card rounded-xl p-8 shadow-card hover:shadow-modal transition-all duration-300 hover:-translate-y-1 border border-border"
            >
              <div className="flex items-start gap-4 mb-6">
                <div className="flex-shrink-0 w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center">
                  <Icon name={prop.icon as any} size={24} variant="solid" className="text-secondary" />
                </div>
                <div>
                  <h3 className="text-xl font-bold font-headline text-primary mb-2">
                    {prop.title}
                  </h3>
                  <p className="text-muted-foreground font-body">
                    {prop.description}
                  </p>
                </div>
              </div>
              
              <ul className="space-y-3">
                {prop.benefits.map((benefit, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <Icon name="CheckCircleIcon" size={20} variant="solid" className="text-success flex-shrink-0 mt-0.5" />
                    <span className="text-foreground font-body">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuePropositionSection;